import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Bell, AlertTriangle, MessageSquare } from 'lucide-react';

const INBOX_KEY = 'solvert_notif_inbox_pwa';

export default function NotificacionesPWA() {
  const navigate = useNavigate();
  const [notifs, setNotifs] = useState([]);

  const cargar = () => {
    try {
      const raw = localStorage.getItem(INBOX_KEY);
      const data = raw ? JSON.parse(raw) : [];
      setNotifs(data.reverse());
    } catch {}
  };

  useEffect(() => { cargar(); }, []);

  const limpiar = () => {
    localStorage.removeItem(INBOX_KEY);
    setNotifs([]);
  };

  const formatFecha = (iso) => {
    const d = new Date(iso);
    return `${String(d.getDate()).padStart(2,'0')}/${String(d.getMonth()+1).padStart(2,'0')} ${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}`;
  };

  const esEmergencia = (n) => n.data?.tipo === 'emergencia';

  return (
    <div className="app-container">
      <div style={{
        background: '#0B0F0D', padding: '14px 20px',
        display: 'flex', alignItems: 'center', gap: 12,
        borderBottom: '1px solid rgba(255,255,255,0.06)',
        position: 'sticky', top: 0, zIndex: 100,
      }}>
        <button onClick={() => navigate('/')}
          style={{ background: 'none', border: 'none', color: '#4CAF50',
            fontSize: 22, cursor: 'pointer', padding: 4 }}>
          ←
        </button>
        <h1 style={{ margin: 0, fontSize: 17, fontWeight: 700, flex: 1, color: '#F4F7F5' }}>
          Notificaciones
        </h1>
        {notifs.length > 0 && (
          <button onClick={limpiar} style={{
            background: 'none', border: '1px solid rgba(255,255,255,0.1)',
            color: '#8A9994', fontSize: 12, fontWeight: 500,
            cursor: 'pointer', borderRadius: 8, padding: '5px 12px',
          }}>
            Limpiar
          </button>
        )}
      </div>

      <div className="page-content">
        {notifs.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '64px 24px' }}>
            <div style={{
              width: 64, height: 64, borderRadius: 18, background: '#161C19',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              margin: '0 auto 16px',
            }}>
              <Bell size={28} color="#4A6058" strokeWidth={1.5} />
            </div>
            <div style={{ fontSize: 16, fontWeight: 700, color: '#F4F7F5', marginBottom: 6 }}>
              Sin notificaciones
            </div>
            <div style={{ fontSize: 13, color: '#8A9994' }}>
              Las alertas y mensajes aparecerán aquí
            </div>
          </div>
        ) : notifs.map((n) => {
          const urgente = esEmergencia(n);
          return (
            <div key={n.id} style={{
              background: urgente ? '#1A0808' : '#161C19',
              borderRadius: 14, padding: 14, marginBottom: 10,
              border: `1px solid ${urgente ? '#3D1515' : 'rgba(255,255,255,0.07)'}`,
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <span style={{
                  display: 'flex', alignItems: 'center', gap: 5,
                  background: urgente ? '#2D0F0F' : '#12382D',
                  color: urgente ? '#EF4444' : '#4CAF50',
                  borderRadius: 6, padding: '3px 9px', fontSize: 11, fontWeight: 700,
                }}>
                  {urgente
                    ? <AlertTriangle size={11} strokeWidth={2.5} />
                    : <MessageSquare size={11} strokeWidth={2} />
                  }
                  {urgente ? 'Emergencia' : 'Mensaje'}
                </span>
                <span style={{ fontSize: 11, color: '#6B7C74', marginLeft: 'auto' }}>
                  {formatFecha(n.fecha)}
                </span>
              </div>
              <div style={{ fontSize: 14, fontWeight: 700, color: '#F4F7F5', marginBottom: 4 }}>
                {n.titulo}
              </div>
              <div style={{ fontSize: 13, color: '#8A9994', lineHeight: 1.5 }}>
                {n.cuerpo}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
